import RequestShiftsContent from '@/components/organisms/request-shifts-content/requestShiftsContent';
import GeneralPageTemplate from '@/components/template/generalPageTemplate';
import { graphql, useStaticQuery } from 'gatsby';

const SolicitudDeTurnos = () => {
    const data = useStaticQuery(graphql`
        query GET_FORM_APPOINTMENTS_REQUESTS {
            allContentfulTemplate(
                filter: {
                    titulo: {
                        eq: "Solicitudes personas privado > Solicitud de turnos"
                    }
                }
            ) {
                nodes {
                    metaInfo {
                        metaTitulo
                        metaDescripcion
                        metaImagen {
                            file {
                                url
                            }
                        }
                        urlCanonical
                        noIndex
                    }
                    migaDePan
                    nombre
                    subtitulo
                    lista
                    estaActivo
                    referencias {
                        ... on ContentfulTemplate {
                            imagen {
                                title
                                file {
                                    url
                                }
                                gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                                svg {
                                    publicURL
                                }
                            }
                            titulo
                            subtitulo
                            descripcion {
                                raw
                            }
                            lista
                            referencias {
                                ... on ContentfulTemplate {
                                    titulo
                                    subtitulo
                                    copyBoton
                                    redireccion
                                    listaJson {
                                        name
                                        value
                                    }
                                }
                            }
                            boton {
                                copy
                                redireccion
                            }
                            secciones {
                                titulo
                                subtitulo
                                referencias {
                                    ... on ContentfulInfoCard {
                                        titulo
                                        descripcion {
                                            raw
                                        }
                                        icono {
                                            title
                                            file {
                                                url
                                            }
                                            gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                                            svg {
                                                publicURL
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    modal {
                        imagen {
                            title
                            file {
                                url
                            }
                            gatsbyImage(width: 700, formats: [AUTO, WEBP], placeholder: BLURRED)
                        }
                        titulo
                        subtitulo
                        nombre
                        descripcion {
                            raw
                        }
                        lista
                        boton {
                            copy
                            redireccion
                        }
                    }
                }
            }
        }
    `);
    const metaData = data?.allContentfulTemplate?.nodes[0]?.metaInfo[0];
    const content = data?.allContentfulTemplate?.nodes[0];
    return (
        <GeneralPageTemplate
            data={metaData}
            hasLoader={true}
            hideSide={true}
            isPrivate={false}
            isActive={content?.estaActivo}
        >
            <RequestShiftsContent contentInfo={content} />
        </GeneralPageTemplate>
    );
};

export default SolicitudDeTurnos;
